var _rect, _path, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryMembershipCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 35,
    viewBox: "0 0 48 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.925,
    y: 0.925,
    width: 46.15,
    height: 32.5651,
    rx: 3.075,
    stroke: "#2148C0",
    strokeOpacity: 0.9,
    strokeWidth: 1.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.396 28.3715C11.3207 28.3715 6.396 23.4468 6.396 17.3715C6.396 11.2962 11.3207 6.37146 17.396 6.37146C23.4713 6.37146 28.396 11.2962 28.396 17.3715C28.396 23.4468 23.4713 28.3715 17.396 28.3715ZM11.9103 24.2531C13.4674 25.4979 15.4024 26.1746 17.396 26.1715C19.4776 26.1745 21.4923 25.4367 23.0797 24.0903C22.3633 23.3552 21.5068 22.7712 20.5607 22.3729C19.6147 21.9747 18.5984 21.7701 17.572 21.7715C16.5078 21.7702 15.455 21.9902 14.4804 22.4174C13.5058 22.8446 12.6306 23.4697 11.9103 24.2531ZM10.3736 22.6735C11.2981 21.6923 12.4137 20.9109 13.6517 20.3774C14.8898 19.844 16.2239 19.5697 17.572 19.5715C18.8718 19.5698 20.1592 19.8249 21.3601 20.3221C22.5611 20.8193 23.652 21.5489 24.5702 22.4689C25.5119 21.1435 26.068 19.5832 26.1768 17.961C26.2856 16.3388 25.9429 14.7181 25.1867 13.2789C24.4305 11.8396 23.2904 10.6379 21.8928 9.80725C20.4952 8.97655 18.8947 8.54928 17.2691 8.57284C15.6434 8.59639 14.056 9.06985 12.6831 9.94069C11.3101 10.8115 10.2053 12.0457 9.49106 13.5063C8.77686 14.9669 8.48126 16.5967 8.63704 18.2151C8.79283 19.8335 9.39391 21.377 10.3736 22.6746V22.6735ZM17.396 18.4715C16.229 18.4715 15.1099 18.0079 14.2847 17.1827C13.4596 16.3576 12.996 15.2384 12.996 14.0715C12.996 12.9045 13.4596 11.7853 14.2847 10.9602C15.1099 10.135 16.229 9.67146 17.396 9.67146C18.5629 9.67146 19.6821 10.135 20.5073 10.9602C21.3324 11.7853 21.796 12.9045 21.796 14.0715C21.796 15.2384 21.3324 16.3576 20.5073 17.1827C19.6821 18.0079 18.5629 18.4715 17.396 18.4715ZM17.396 16.2715C17.9795 16.2715 18.539 16.0397 18.9516 15.6271C19.3642 15.2145 19.596 14.6549 19.596 14.0715C19.596 13.488 19.3642 12.9284 18.9516 12.5158C18.539 12.1032 17.9795 11.8715 17.396 11.8715C16.8125 11.8715 16.2529 12.1032 15.8404 12.5158C15.4278 12.9284 15.196 13.488 15.196 14.0715C15.196 14.6549 15.4278 15.2145 15.8404 15.6271C16.2529 16.0397 16.8125 16.2715 17.396 16.2715Z",
    fill: "#2148C0",
    fillOpacity: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.7925,
    y: 10.1709,
    width: 12.4016,
    height: 2.28571,
    rx: 1.14286,
    fill: "#2148C0",
    fillOpacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.7925,
    y: 16.1709,
    width: 12.4016,
    height: 2.28571,
    rx: 1.14286,
    fill: "#2148C0",
    fillOpacity: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.7925,
    y: 22.1709,
    width: 12.4016,
    height: 2.28571,
    rx: 1.14286,
    fill: "#2148C0",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryMembershipCard);
export default __webpack_public_path__ + "static/media/primaryMembershipCard.9725bebbe48ae76c2d8b3c06316810dd.svg";
export { ForwardRef as ReactComponent };